(function () {
  'use strict';

  let sharedLightbox = null;
  let activeImages = [];
  let currentIndex = 0;
  let productTitle = '';

  function createLightbox() {
    const lightbox = document.createElement('div');
    lightbox.className = 'stationary-gallery-lightbox';
    lightbox.hidden = true;
    lightbox.innerHTML = `
      <button type="button" class="stationary-gallery-lightbox__backdrop" data-stationary-gallery-close aria-label="Zamknij galerię"></button>
      <div class="stationary-gallery-lightbox__stage">
        <div class="stationary-gallery-lightbox__frame" role="dialog" aria-modal="true" aria-label="Podgląd zdjęcia">
          <div class="stationary-gallery-lightbox__image-wrap">
            <img class="stationary-gallery-lightbox__image" data-stationary-gallery-lightbox-image src="" alt="">
          </div>
          <div class="stationary-gallery-lightbox__footer">
            <p class="stationary-gallery-lightbox__caption" data-stationary-gallery-lightbox-caption></p>
            <button type="button" class="stationary-gallery-lightbox__close" data-stationary-gallery-close aria-label="Zamknij">
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        <button type="button" class="stationary-gallery-lightbox__nav stationary-gallery-lightbox__nav--prev" data-stationary-gallery-prev aria-label="Poprzednie zdjęcie" hidden>
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button type="button" class="stationary-gallery-lightbox__nav stationary-gallery-lightbox__nav--next" data-stationary-gallery-next aria-label="Następne zdjęcie" hidden>
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function getLightbox() {
    if (!sharedLightbox) {
      sharedLightbox = createLightbox();
      bindLightboxEvents(sharedLightbox);
    }
    return sharedLightbox;
  }

  function updateLightboxImage(lightbox) {
    const image = activeImages[currentIndex];
    if (!image) return;

    const imageEl = lightbox.querySelector('[data-stationary-gallery-lightbox-image]');
    const captionEl = lightbox.querySelector('[data-stationary-gallery-lightbox-caption]');
    const prevBtn = lightbox.querySelector('[data-stationary-gallery-prev]');
    const nextBtn = lightbox.querySelector('[data-stationary-gallery-next]');
    const showNav = activeImages.length > 1;

    imageEl.src = image.fullUrl;
    imageEl.alt = image.alt;
    captionEl.textContent = `${productTitle} · ${currentIndex + 1}/${activeImages.length}`;
    prevBtn.hidden = !showNav;
    nextBtn.hidden = !showNav;
  }

  function openLightbox(images, index, title) {
    activeImages = images;
    currentIndex = index;
    productTitle = title;

    const lightbox = getLightbox();
    updateLightboxImage(lightbox);
    lightbox.hidden = false;
    requestAnimationFrame(() => lightbox.classList.add('is-open'));
    document.body.classList.add('stationary-gallery-lightbox-open');
  }

  function closeLightbox() {
    const lightbox = sharedLightbox;
    if (!lightbox || lightbox.hidden) return;

    lightbox.classList.remove('is-open');
    document.body.classList.remove('stationary-gallery-lightbox-open');

    window.setTimeout(() => {
      if (!lightbox.classList.contains('is-open')) {
        lightbox.hidden = true;
      }
    }, 250);
  }

  function stepLightbox(delta) {
    if (activeImages.length <= 1) return;
    currentIndex = (currentIndex + delta + activeImages.length) % activeImages.length;
    updateLightboxImage(getLightbox());
  }

  function bindLightboxEvents(lightbox) {
    lightbox.addEventListener('click', (event) => {
      if (event.target.closest('[data-stationary-gallery-close]')) {
        closeLightbox();
        return;
      }

      if (event.target.closest('[data-stationary-gallery-prev]')) {
        stepLightbox(-1);
        return;
      }

      if (event.target.closest('[data-stationary-gallery-next]')) {
        stepLightbox(1);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!document.body.classList.contains('stationary-gallery-lightbox-open')) return;

      if (event.key === 'Escape') {
        event.stopImmediatePropagation();
        closeLightbox();
        return;
      }

      if (activeImages.length <= 1) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stepLightbox(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        stepLightbox(1);
      }
    });
  }

  function initStationaryCourseGallery(section) {
    const galleries = section.querySelectorAll('[data-stationary-gallery]');
    if (!galleries.length) return;

    const fallbackTitle = section.dataset.productTitle || '';

    galleries.forEach((gallery) => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';

      const title =
        gallery.querySelector('.stationary-groups__gallery-title')?.textContent?.trim() || fallbackTitle;
      const grid = gallery.querySelector('[data-stationary-gallery-grid]');

      function getAllItems() {
        const gridItems = Array.from(grid?.querySelectorAll('[data-stationary-gallery-item]') || []);
        const extraTemplate = gallery.querySelector('[data-stationary-gallery-extra]');

        if (!extraTemplate) {
          return gridItems;
        }

        const extraItems = Array.from(
          extraTemplate.content.querySelectorAll('[data-stationary-gallery-item]'),
        );
        return gridItems.concat(extraItems);
      }

      function buildImages() {
        return getAllItems().map((item) => ({
          fullUrl: item.getAttribute('data-full-url') || '',
          alt: item.querySelector('img')?.alt || title,
        }));
      }

      if (grid && !grid.dataset.galleryBound) {
        grid.dataset.galleryBound = 'true';
        grid.addEventListener('click', (event) => {
          const item = event.target.closest('[data-stationary-gallery-item]');
          if (!item || !grid.contains(item)) return;

          const images = buildImages();
          const index = getAllItems().indexOf(item);
          if (index === -1) return;

          openLightbox(images, index, title);
        });
      }

      const toggle = gallery.querySelector('[data-stationary-gallery-toggle]');
      const extraTemplate = gallery.querySelector('[data-stationary-gallery-extra]');

      if (toggle && !toggle.dataset.bound) {
        toggle.dataset.bound = 'true';
        toggle.addEventListener('click', () => {
          if (extraTemplate && grid) {
            grid.appendChild(extraTemplate.content.cloneNode(true));
            extraTemplate.remove();
          }
          toggle.hidden = true;
        });
      }
    });
  }

  window.initStationaryCourseGallery = initStationaryCourseGallery;
})();
